module.exports = {
    template: '<textarea id="HtmlContent" :name="name"></textarea>',
    props: {
        model: {
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        toolFontSize:{
            type: Boolean,
            default: false
        },
        toolColor:{
            type: Boolean,
            default: false
        },
        toolInsert:{
            type: Array,
            default: () => []
        },
        height: {
            type: [Number, String],
            default: '150'
        },
        toolLink: {
            type: Boolean,
            default: false
        },
        toolCodeView: {
            type: Boolean,
            default: false
        },
        toolDisable: {
            type: Boolean,
            default: false
        },
        toolHidden: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: ''
        },
        toolBar: {
            type: Boolean,
            default: true
        },
    },

    mounted() {
        // if (!$().summernote) {
        //     console.warn('Warning - summernote.min.js is not loaded.');
        //     return;
        // }
        
        
        let vm = this;
        let toolbarSetting = [];
        if(!this.toolHidden) {
            toolbarSetting.push(['style', ['style']]);
            toolbarSetting.push(['style', ['bold', 'italic', 'underline']]);
            // toolbarSetting.push(['fontsize', ['fontsize']]);
            // toolbarSetting.push(['color', ['color']]);
            toolbarSetting.push(['para', ['ul', 'ol', 'paragraph']]);
            // toolbarSetting.push(['insert', ['link']]);
            // toolbarSetting.push(['view', ['codeview']]);
        }
        var config =  {
            height: this.height,
            fontSizes: ['12', '14', '18', '20', '22', '24'],
            dialogsInBody: true,
            placeholder: this.placeholder,
            toolbar: toolbarSetting
        };


        // const options = {
        //     lang: 'en-US',
        //     height: 600,
        //     dialogsInBody: true,
        //     fontSizes: ['8', '9', '10', '11', '12', '13', '14', '15', '16', '18', '20', '24', '30', '36', '48' , '64', '82', '150'],
        //     toolbar: [
        //       ['style', ['style']],
        //       ['font', ['bold', 'underline', 'clear', 'strikethrough', 'superscript', 'subscript']],
        //       ['fontname', ['fontname']],
        //       ['para', ['ul', 'ol', 'paragraph']],
        //       ['table', ['table']],
        //       ['color', ['color']],
        //       ['insert', ['link', 'picture', 'video']],
        //       ['view', ['fullscreen', 'codeview']],
        //       ['height', ['height']],
        //       ['fontsize', ['fontsize']]
        //     ]
        //   };

// console.log(config['toolbar']);
        if(this.toolColor){ config['toolbar'].push(['color', ['color']])}
        if(this.toolFontSize){ config['toolbar'].push(['fontsize', ['fontsize']])}
        if(this.toolLink){ config['toolbar'].push(['insert', ['link']])}
        if(this.toolCodeView){ config['toolbar'].push(['view', ['codeview']])}
        if(!this.toolBar){config['toolbar'] = []}


        //toolInsert


        config.callbacks = {
            onInit: function () {
                $(vm.$el).summernote("code", vm.model);
            },
            onChange: function () {
                vm.$emit('change', $(vm.$el).summernote('code'), this.name);
            },
            onBlur: function () {
                vm.$emit('change', $(vm.$el).summernote('code'), this.name);
            },
            onPaste: function (e) {
                e.preventDefault();
                var text = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('text/plain');
                document.execCommand('insertText', false, text);
            }
        };
        $(this.$el).summernote(config);

        if(this.toolDisable){$(this.$el).summernote('disable')}

        $('.note-editor  li[aria-label="blockquote"]').remove();
        $('.note-editor  li[aria-label="pre"]').remove();
        $('.note-editor div.note-group-select-from-files').remove();
    },
    methods: {
        setData(data) {
            let vm = this;
            $(vm.$el).summernote("code", data);
        }
    },
    watch: {
        model(nval){
            this.setData(nval);
        }
    },
    // head () {
    //     return {
    //       script: [
    //         { type: 'text/javascript', src: "https://code.jquery.com/jquery-3.2.1.slim.min.js", async: false, body: true},
    //         { type: 'text/javascript', src: "https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.11.0/umd/popper.min.js", async: false, body: true},
    //         { type: 'text/javascript', src: "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0-beta/js/bootstrap.min.js", async: false, body: true},
    //         { type: 'text/javascript', src: "https://cdnjs.cloudflare.com/ajax/libs/summernote/0.8.9/summernote-bs4.js", async: false, body: true},
    //       ]
    //     }
    //   },
}


// WEBPACK FOOTER //
// ./src/plugins/summernote.js